// App.jsx

import { useAuth } from "react-oidc-context";
import { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Sidebar from "./Sidebar"; // likely not route-based, leave as is
import "./App.css";

import { MdMenu } from "react-icons/md";
import { useMediaQuery } from "@mui/system";
import { IconButton } from "@mui/material";

// Lazy-loaded route components
const Dashboard = lazy(() => import("./Dashboard/Dashboard.jsx"));
const Installations = lazy(() => import("./Installations/Installations"));
const InstallationDetails = lazy(
  () => import("./InstallationDetails/InstallationDetails"),
);
const Users = lazy(() => import("./Users/Users.jsx"));
const UserDetails = lazy(() => import("./Users/UserDetails.jsx"));
const Organizations = lazy(() => import("./Organizations/Organizations.jsx"));
const OrganizationDetails = lazy(
  () => import("./Organizations/OrganizationDetails.jsx"),
);
const GeneralSettingsForm = lazy(
  () => import("./Installations/Settings/InstallationSettings"),
);
const GlobalSettings = lazy(()=> import("./GlobalSettings/GlobalSettings.jsx"))

function App() {
  const auth = useAuth();
  const isMobile = useMediaQuery("(max-width:900px)");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  useEffect(() => {
    // Get the full URL and extract the code parameter
    const params = new URLSearchParams(window.location.search);
    const authCode = params.get("code");
    if (auth.isLoading) {
      return;
    }
    if (authCode) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [auth]);

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    console.log("Got authentication error: " + auth.error?.message);
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        height: "100vh",
        boxSizing: "border-box",
      }}
    >
      <Router>
        {isMobile && (
          <IconButton
            onClick={() => setSidebarOpen(true)}
            sx={{ position: "fixed", top: 10, left: 10, zIndex: 1300 }}
          >
            <MdMenu sx={{ color: "white" }} />
          </IconButton>
        )}

        <Sidebar
          onItemClick={() => {}}
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          isMobile={isMobile}
        />

        <div
          style={{
            flex: 1,
            paddingLeft: isMobile ? 0 : "20px",
            background: "white",
            color: "black",
            marginLeft: isMobile ? 0 : "0px",
            overflowY: "scroll",
          }}
        >
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/installations" element={<Installations />} />
              <Route
                path="/installations/:id"
                element={<InstallationDetails />}
              />
              <Route path="/users" element={<Users />} />
              <Route path="/users/:sub" element={<UserDetails />} />
              <Route
                path="/installations/:id/settings"
                element={<GeneralSettingsForm />}
              />
              <Route path="/organizations" element={<Organizations />} />
              <Route
                path="/organizations/:org"
                element={<OrganizationDetails />}
              />
              <Route
                path="/settings/"
                element={<GlobalSettings />}
              />
            </Routes>
          </Suspense>
        </div>
      </Router>
    </div>
  );
}

export default App;
